import {ProductPropertyDescription} from "./ProductPropertyDescription";

export class ProductPropertyGroupDescription {
    constructor(public Id: number,
                public Name: string,
                public TranslatedName: string,
                public PropertyMode: string,
                public Properties: ProductPropertyDescription[]) {
    }
}